<template>
  <ValidationObserver ref="form" slim>
    <div v-if="tapRequestId && loaded" class="row">
      <slot name="Observations" />
      <div class="col-12">
        <!-- {{ requestTypeId }} -->
        <FacilitatorInquiries
          :submitted-date="model.submittedDate"
          :person-who-attends="personWhoAttends"
          :can-delete="canDeleteFacilitatorInquiries"
          :is-read-only="
            readonly || sectionsStates[enums.sections['Consultas']].readonly
          "
          :value="model.inquiries"
          title="Consultas"
        />
      </div>

      <div class="col-12 pt-3">
        <SectionTitle
          :has-line="true"
          content="Del proceso de análisis, se recomienda:"
        />
      </div>

      <div class="col-12">
        <CollapsibleItem
          :disabled="
            readonly ||
              sectionsStates[enums.sections['Recomendar Reunion COMPU']]
                .readonly
          "
          :active.sync="collapseTogglers.compuRecommendations"
          activator-text="Se recomienda que se reúna el COMPU para"
          @update:active="deleteCOMPURecommendation($event)"
        >
          <div class="bg-light-gray p-3">
            <ValidationProvider
              name="Recomendaciones COMPU"
              v-slot="{ errors, validate }"
              :rules="{ required: true }"
              :custom-messages="{
                required:
                  'Favor seleccionar al menos una opción que recomiende que el COMPU se reúna.',
              }"
            >
              <input
                type="hidden"
                required
                :value="model.compuRecommendations.length > 0 ? '1' : ''"
              />
              <ORERecommendations
                :disabled="
                  readonly ||
                    sectionsStates[enums.sections['Recomendar Reunion COMPU']]
                      .readonly
                "
                :questionnaire="catalogs.oreRecommendations.questionnaire"
                :answers.sync="model.compuRecommendations"
                :subject="
                  tapRequestQuestionSectionsEnum.OreRecomendacionNivelCentral
                "
                :validate="validate"
                @input="() => needToValidate && validate()"
              />
              <Error
                v-if="errors[0]"
                variant="no-border"
                :message="errors[0]"
              />
            </ValidationProvider>
          </div>
        </CollapsibleItem>
      </div>

      <div class="col-12">
        <CollapsibleItem
          :disabled="
            readonly ||
              sectionsStates[enums.sections['Búsqueda Localizacion Disponible']]
                .readonly
          "
          :active.sync="collapseTogglers.schoolRecommendations"
          activator-text="Se identifica la alternativa de ubicación y/o localización"
          @update:active="deleteSchoolRecommendation($event)"
        >
          <div class="bg-light-gray p-3">
            <ValidationProvider
              name="Alternativa de ubicación y/o localización"
              v-slot="{ errors, validate }"
              :rules="{
                required:
                  !sectionsStates[
                    enums.sections['Búsqueda Localizacion Disponible']
                  ].readonly && needToValidate
                    ? { allowFalse: false }
                    : false,
              }"
              :custom-messages="{
                required: 'Favor recomendar la alternativa de ubicación.',
              }"
            >
              <input
                type="hidden"
                required
                :value="model.schoolRecommendations.length > 0 ? '1' : ''"
              />
              <SchoolRecommendation
                :readonly="
                  readonly ||
                    sectionsStates[
                      enums.sections['Búsqueda Localizacion Disponible']
                    ].readonly
                "
                :academic-year-id="model.academicYearId"
                :tap-request-id="tapRequestId"
                :tap-request-type-id="tapRequestTypeId"
                select-region
                select-municipality
                :items.sync="model.schoolRecommendations"
                @input="() => needToValidate && validate()"
              />
              <Error
                v-if="errors[0]"
                variant="no-border"
                :message="errors[0]"
              />
            </ValidationProvider>
          </div>
        </CollapsibleItem>
      </div>

      <div class="col-12">
        <ValidationProvider
          name="Documento Propuesta de Servicios"
          v-slot="{ validate, errors }"
          vid="document"
          :rules="{
            required:
              !isSectionDocumentReadOnly && needToValidate
                ? { allowFalse: false }
                : false,
          }"
          :custom-messages="{
            required:
              'Es requerido anejar el documento de Propuesta de Servicios.',
          }"
        >
          <input
            type="hidden"
            :value="validateDocument ? '1' : ''"
            :required="
              !isSectionDocumentReadOnly && needToValidate ? true : false
            "
          />

          <Documents
            :key="documentLength"
            :disabled="readonly || isSectionDocumentReadOnly"
            :documents="getDocumentData"
            :document-types="document.documentTypes"
            :invalid-types="getInvalidDocumentTypes"
            :center-title-header="'Documentos'"
            @input="() => needToValidate && validate(validateDocument)"
            @files="
              gettingDocument($event);
              if (validate)
                validate(document.data && !![...document.data.files].length);
            "
          />
          <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
        </ValidationProvider>
      </div>

      <div class="col-12">
        <StudentTransfer
          :request="model"
          :model-to-save.sync="model.transfer"
          :academic-year-id="model.academicYearId"
          :validate="
            needToValidate &&
              !readonly &&
              !sectionsStates[enums.sections['Traslado Estudiante']].readonly
          "
          :readonly="
            readonly ||
              sectionsStates[enums.sections['Traslado Estudiante']].readonly
          "
          @on-valid-contract-change="onValidContractChange"
          @on-therapy-service-reset="clearNotRelatedTherapyService"
        />
      </div>

      <div class="col-12">
        <template v-if="canViewLocationAlternative">
          <LocationAlternative
            v-model="model.alternativeLocation"
            :collections="catalogs"
            :validate="
              needToValidate &&
                !readonly &&
                !sectionsStates[enums.sections['Traslado Estudiante']].readonly
            "
            :readonly="
              readonly ||
                sectionsStates[enums.sections['Traslado Estudiante']].readonly
            "
          />
        </template>
      </div>

      <div class="col-12">
        <ValidationProvider
          name="Resumen de servicios"
          v-slot="{ validate, errors }"
          :rules="{
            required: this.validateServiceSumarry
              ? { allowFalse: false }
              : false,
          }"
          :custom-messages="{
            required: 'Favor de añadir al menos un servicio.',
          }"
        >
          <!-- fix: needed for VeeValidate to bind the value to know what to validate -->
          <input
            type="hidden"
            :required="validateServiceSumarry"
            :value="servicesSummary.length > 0"
          />

          <ServicesSummary
            :services="servicesSummary"
            :collections="availableCatalogOptions"
            :costByServices="costByServicesCached"
            :hideTotal="false"
            :readonly="
              readonly ||
                sectionsStates[enums.sections['Traslado Estudiante']].readonly
            "
            :cost-readonly="isCostReadOnly"
            :isAcceptBtnDisabled="isAcceptBtnDisabled"
            :statusId="statusId"
            :academic-year-id="model.academicYearId"
            :school-id="student?.schoolId"
            @on-service-change="onServiceChange"
            @input="() => needToValidate && validate()"
            @add-service="addServiceToSummary"
            @remove-service="removeServiceFromSummary"
          />

          <Error
            v-if="errors[0] && validateServiceSumarry"
            variant="no-border"
            :message="errors[0]"
          />
        </ValidationProvider>
        <RetroactivePayments
          :key="retroactiveDocumentLength"
          v-if="shouldShowRetroactivePayments"
          v-model="model"
          :readonly="readonly"
          :need-to-validate="validateServiceSumarry"
          :document-types="filteredRetroactiveDocumentTypesCatalog"
          :is-complaint-request="requestTypeId === requestTypes.QUERELLA"
        />
      </div>
      <div class="my-3 col-12">
        <Requesters
          keep-signed
          :allow-add-more="false"
          :submitted="
            readonly ||
              sectionsStates[enums.sections['Funcionarios Solicitan']].readonly
          "
          :requesters="model.requesters"
          :positions-list="requestersPositionsList"
          :cannot-edit-name="true"
          :use-role="true"
          title="Firma de Asistente Técnico"
          @input="() => needToValidate && validate()"
        />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CollapsibleItem from '../CollapsibleItem';
import {
  FacilitatorInquiries,
  ORERecommendations,
  SchoolRecommendation,
  Documents,
  StudentTransfer,
  Requesters,
} from '@/components/pei/ubication-tech-assistance/_components';
import store from '@/store/index';
import {
  getCentralLevel,
  getDocumentTypesByCode,
  deleteCOMPURecommendation,
  deleteSchoolRecommendation,
  getCentralLevelAlternativeLocationCategories,
  getCentralLevelNumberOfStudents,
  getCentralLevelServices,
  getCentralLevelSchoolGrades,
  getTherapyservicesfilters,
  getServiceTotalCost,
  getServiceCost,
  isSchoolContractDirectPayment as _isSchoolContractDirectPayment,
  getServiceToShowBillFlag,
} from '@/services/api/tapRequest.api';

import {
  tapRequestTypesEnum,
  tapRequestQuestionSectionsEnum,
} from '@/components/pei/ubication-tech-assistance/_types';
import { getORERecommendations } from '@/components/pei/ubication-tech-assistance/_api';
import alert from 'utils/mixins/alert.mixin';
import Error from 'custom-error';
import { UTA_MANAGEMENT_SECTION_ENUM } from '@/components/pei/ubication-tech-assistance/_config/management';
import documentTypes from '@/utils/constants/documentTypes.js';
import LocationAlternative from './components/LocationAlternative.vue';
import ServicesSummary from './components/ServicesSummary/Main.vue';
import { serviceEnum } from '@/components/pei/ubication-tech-assistance/management/_types.js';
import InstitutionServiceCodes from '@/utils/constants/pei/ubication-tech-assistance/institutionServiceCodes';
import { servicesProvidedApi } from '@/components/pei/ubication-tech-assistance/_components/ServicesProvided/_api';
import { isTapRelatedFilter } from '@/components/pei/ubication-tech-assistance/_components/ServicesProvided/_utils';
import centralLevelServicesCategories from '@/utils/constants/tapRequest/centralLevelServicesCategories';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import RetroactivePayments from './components/RetroactivePayments.vue';
import centralLevelServices from '@/utils/constants/tapRequest/centralLevelServices.js';

import moment from 'moment';

const REQUEST_TYPES = {
  NUEVO: 1,
  RENOVACION: 2,
  QUERELLA: 3,
};

export default {
  name: 'CentralLevelAnalisys',
  inject: { studentSieId: { default: 0 }, tapRequestId: { default: 0 } },
  components: {
    SectionTitle,
    CollapsibleItem,
    FacilitatorInquiries,
    ORERecommendations,
    SchoolRecommendation,
    Documents,
    StudentTransfer,
    Requesters,
    LocationAlternative,
    ServicesSummary,
    Error,
    ValidationProvider,
    ValidationObserver,
    RetroactivePayments,
  },
  props: {
    readonly: { type: Boolean, default: false },
    modelToSave: { type: Object, default: () => {} },
    needToValidate: { type: Boolean, default: false },
    validateServiceSumarry: { type: Boolean, default: false },
    sectionsStates: { type: Object, default: () => ({}) },
    student: { type: Object, default: () => ({}) },
    requestTypeId: { type: Number, default: 0 },
    isAmendment: { type: Boolean, default: false },
    statusId: { type: Number, default: 0 },
  },
  data: () => ({
    retroactiveDocumentLength: 0,
    documentLength: 0,
    enums: { sections: UTA_MANAGEMENT_SECTION_ENUM },
    loaded: false,
    collapseTogglers: {
      schoolRecommendations: false,
      compuRecommendations: false,
    },
    document: {
      documentTypes: [],
      // Variables to save component data.
      data: {
        files: [],
        types: [],
      },
    },
    tapRequestTypeId: tapRequestTypesEnum.CentralLevelAnalysis,
    model: {
      studentSieId: null,
      academicYearId: null,
      region: null,
      municipality: null,
      submittedDate: null,
      inquiries: [],
      documents: [],
      schoolRecommendations: [],
      compuRecommendations: [],
      status: null,
      requesters: [],
      transfer: null,
      alternativeLocation: {
        alternativeLocationCategory: null,
        numberOfStudents: null,
        comment: null,
        grade: null,
      },
      servicesSummary: [],
      hasRetroactivePaymentAuthorization: null,
      retroactivePaymentJustification: '',
      retroactivePaymentDocuments: {
        files: [],
        types: [],
      },
    },
    sysParameters: {},
    servicesSummaryBackup: [],
    relatedServices: [],
    catalogs: {
      oreRecommendations: {
        questionnaire: {},
      },
      alternativeLocationCategories: [],
      numberOfStudents: [],
      schoolGrades: [],
      services: [],
      itinerantServices: [],
      servicesPreviousYear: [],
      frequencies: [],
      modalities: [],
      durations: [],
    },
    tapRequestQuestionSectionsEnum,
    requestersPositionsList: [],
    costByServices: [],
    retroactiveDocumentTypesCatalog: [],
    schoolHasValidContract: null,
    disableAcceptBtn: null,
    isSchoolContractDirectPayment: false,
  }),
  computed: {
    requestTypes() {
      return REQUEST_TYPES;
    },
    filteredRetroactiveDocumentTypesCatalog() {
      const usedTypes = this.model.retroactivePaymentDocuments?.types || [];

      return this.retroactiveDocumentTypesCatalog.filter(
        (docType) => !usedTypes.includes(docType.id)
      );
    },
    retroactiveDocumentTypeIds() {
      return this.retroactiveDocumentTypesCatalog.map((x) => x.id);
    },
    servicesSummary() {
      const endDate = this.sysParameters.LastSchoolDate?.staticValue;

      return this.model.servicesSummary.map((service) => {
        if (!endDate || !this.model.submittedDate) return service;

        const applies = [
          centralLevelServices.MonthlyPayment,
          centralLevelServices.ServiceAssistant,
        ].includes(service.service?.id);

        if (!applies) {
          service.serviceDate = null;
          return service;
        }

        // Se le resta 1 para que el mes de la fecha de sometido sea considerada como el inicio del servicio
        const months =
          Number(
            service.months || service.quantityMonths || service.frequency || 0
          ) - 1;

        if (!months) {
          service.serviceDate = null;
          return service;
        }

        service.serviceDate = moment(this.model.submittedDate).add(
          months,
          'months'
        );

        return service;
      });
    },
    shouldShowRetroactivePayments() {
      const endDate = this.sysParameters.LastSchoolDate?.staticValue;
      return this.servicesSummary.some((x) =>
        endDate && x.serviceDate
          ? moment(x.serviceDate).isAfter(moment(endDate), 'month')
          : false
      );
    },
    isStatusProcessAmmendment() {
      return this.statusId === tapRequestStatusesEnum['Proceso de Enmienda'];
    },
    hasProposalServiceFile() {
      return (
        this.getDocumentData &&
        this.getDocumentData.files &&
        this.getDocumentData.files.length > 0 &&
        this.getDocumentData.types.includes(documentTypes.PropuestaServicios)
      );
    },
    serviceSummarytherapies() {
      return (
        this.model.servicesSummary?.filter(
          (x) =>
            x?.service?.categoryId ===
            centralLevelServicesCategories.TherapyServices
        ) ?? []
      );
    },
    isAcceptBtnDisabled() {
      let isDisabled = false;

      if (this.isServicePurchaseSelected) {
        return this.disableAcceptBtn;
      }

      return isDisabled;
    },
    isCostReadOnly() {
      return (
        this.schoolHasValidContract === false && this.isServicePurchaseSelected
      );
    },
    costByServicesCached() {
      // if user doesn't select "Compra de Servicio" in student's transfer then send the empty list.
      const result = this.canWriteCustomCost ? [] : this.costByServices;
      return result;
    },
    transfer() {
      const transfer = this.model.transfer ?? {};
      return transfer;
    },
    destinationLocationSchoolId() {
      return this.transfer.destinationLocationSchool?.id;
    },
    isServicePurchaseSelected() {
      return (
        this.transfer?.institutionServiceCode?.id ==
        InstitutionServiceCodes.ServicePurchase
      );
    },
    canWriteCustomCost() {
      const hasSelectedSchool = this.destinationLocationSchoolId > 0;
      const result = !this.isServicePurchaseSelected || !hasSelectedSchool;
      !this.schoolHasValidContract;

      return result;
    },
    isSectionDocumentReadOnly() {
      return this.sectionsStates[this.enums.sections['Documentos']].readonly;
    },
    personWhoAttends() {
      return (
        this.userProfile.firstname + ' ' + this.userProfile.lastpaternalname
      );
    },
    canDeleteFacilitatorInquiries() {
      return store.getters.HasPermission('facilitator.inquiries.delete');
    },
    canViewLocationAlternative() {
      return (
        !this.readonly ||
        (this.readonly &&
          store.getters.HasPermission(
            'taprequest.centrallevel.alternativelocation.view'
          ))
      );
    },
    getDocumentData() {
      return this.document.data;
    },
    getInvalidDocumentTypes() {
      if (this.requestTypeId === REQUEST_TYPES.QUERELLA) {
        const documentTypeEnum = {
          propuestaServicios: 196,
        };
        const invalidTypes = [];

        if (
          this.document.data.types.filter(
            (x) => x === documentTypeEnum.propuestaServicios
          ).length > 0
        ) {
          invalidTypes.push(documentTypeEnum.propuestaServicios);
        }

        return invalidTypes;
      } else {
        return [];
      }
    },
    validateDocument() {
      if (this.requestTypeId === REQUEST_TYPES.QUERELLA) {
        const documentTypeEnum = {
          propuestaServicios: 196,
          propuestaServiciosCentral: 209,
          requestPropuestaServicios: 219,
        };

        return (
          this.document.data &&
          !![...this.document.data.files].length &&
          this.document.data.types.filter(
            (x) =>
              x === documentTypeEnum.propuestaServicios ||
              x === documentTypeEnum.propuestaServiciosCentral ||
              x === documentTypeEnum.requestPropuestaServicios
          ).length > 0
        );
      } else {
        return this.document.data && !![...this.document.data.files].length;
      }
    },
    availableCatalogOptions() {
      return {
        services: this.catalogs?.services?.filter(
          (s) =>
            s.id === serviceEnum.Other ||
            this.model.servicesSummary.every((ss) => ss.service.id != s.id)
        ),
        servicesPreviousYear: this.catalogs?.servicesPreviousYear,
        itinerantServices: [
          { id: true, name: 'Si' },
          { id: false, name: 'No' },
        ],
        frequencies: this.catalogs?.frequencies,
        modalities: this.catalogs?.modalities,
        durations: this.catalogs?.durations,
      };
    },
  },
  async mounted() {
    await this.getCatalogs();

    await Promise.all([
      this.getDocumentTypesByCode('TapRequestCentralLevel'),
      this.getRetroactiveDocumentTypes(),
      this.getServices(),
      this.fetchIsSchoolContractDirectPayment(),
    ]);

    await this.getData();
    await this.loadSysParam();

    this.initTogglers();
    this.loaded = true;
  },
  methods: {
    async fetchIsSchoolContractDirectPayment() {
      if (!this.tapRequestId) return;
      try {
        const { data } = await _isSchoolContractDirectPayment(
          this.tapRequestId
        );
        this.isSchoolContractDirectPayment = data;
      } catch {
        this.isSchoolContractDirectPayment = false;
      }
    },
    getRetroactivePaymentFiles(documents) {
      const validTypes = this.retroactiveDocumentTypeIds;

      return documents
        .filter((x) => validTypes.includes(x.document.documentTypeId))
        .map((element) => ({
          name: element.filename,
          peiStatus: element.peiStatus,
          pei: element.peiId,
          documentType: element.document.documentTypeId,
          documentTypeName: element.document.documentTypeName,
          id: element.documentId,
          inServer: true,
          isReport: element.isReport,
          readOnly: element.readOnly,
          createdDate: element.createdDate,
          userName: element.userName,
          userFullName: element.userFullName,
          isAmendmentDocument: element.isAmendmentDocument,
        }));
    },

    getRetroactivePaymentTypes(documents) {
      const validTypes = this.retroactiveDocumentTypeIds;

      return documents
        .filter((x) => validTypes.includes(x.document.documentTypeId))
        .map((x) => x.document.documentTypeId);
    },
    async getRetroactiveDocumentTypes() {
      const result = [];

      const { data: tapRequestTypes } = await getDocumentTypesByCode(
        'TapRequestCentralLevel'
      );

      const { data: serviceRequestTypes } = await getDocumentTypesByCode(
        'Solicitud_Servicio'
      );

      const allTypes = [...tapRequestTypes, ...serviceRequestTypes];

      const validDocumentTypes = [
        documentTypes.ResolucionJuez,
        documentTypes.DocumentoConsulta,
        documentTypes.CopiaDeQuerella,
      ];

      validDocumentTypes.forEach((documentTypeId) => {
        const found = allTypes.find((x) => x.id === documentTypeId);

        if (found && !result.some((x) => x.id === found.id)) {
          result.push({
            id: found.id,
            name: found.name,
          });
        }
      });

      this.retroactiveDocumentTypesCatalog = result;
    },
    async loadSysParam() {
      if (!this.model.academicYearId) return;

      const { data } = await getSysparameterByNames({
        academicYearId: this.model.academicYearId,
        parameterNames: ['LastSchoolDate'],
      });

      this.sysParameters = data.reduce(
        (acc, current) => ({
          ...acc,
          [current.name]: current,
        }),
        this.sysParameters
      );
    },
    clearNotRelatedTherapyService(schoolId) {
      schoolId = schoolId ?? 0;
      const isSameSchool = schoolId === this.student?.schoolId;
      const hasTherapyServices = this.serviceSummarytherapies.length > 0;
      if (hasTherapyServices && !isSameSchool) {
        this.model.servicesSummary = this.model.servicesSummary.filter(
          (x) =>
            x.service?.categoryId !==
            centralLevelServicesCategories.TherapyServices
        );
      } else if (isSameSchool) {
        this.model.servicesSummary = [...this.servicesSummaryBackup];
      }
    },
    onValidContractChange(hasValidContract) {
      this.schoolHasValidContract = hasValidContract;
    },
    async getData() {
      const { data } = await getCentralLevel(this.tapRequestId);
      this.model = {
        ...this.model,
        ...data,
        schoolRecommendations: data.recomendations || [],
        document: this.document,
        requesters: data.staffMembers.map((c) => {
          return {
            id: c.id,
            status: c.status,
            userName: c.userName,
            name: c.fullName,
            email: c.email,
            phone: c.telephoneNumber,
            signed: c.signed,
            role: {
              id: c.rolId,
              name: c.rol,
            },
            signDate: c.signDate,
          };
        }),
        alternativeLocation:
          data.alternativeLocation || this.model.alternativeLocation,
        servicesSummary: data.servicesSummary
          ? (this.model.servicesSummary = data.servicesSummary.map(
              (serviceSum) => ({
                ...serviceSum,
                therapyServiceModality: this.availableCatalogOptions.modalities.find(
                  (x) => x.id == serviceSum.therapyServiceModalityId
                ),
                therapyFrequency: this.availableCatalogOptions.frequencies.find(
                  (x) => x.id == serviceSum.therapyFrequencyId
                ),
                therapyDuration: this.availableCatalogOptions.durations.find(
                  (x) => x.id == serviceSum.therapyDurationId
                ),
                itinerantService: this.availableCatalogOptions.itinerantServices.find(
                  (x) => x.id == serviceSum.itinerantService
                ),
              })
            ))
          : this.model.servicesSummary,
        hasRetroactivePaymentAuthorization:
          data.hasRetroactivePaymentAuthorization ?? null,

        retroactivePaymentJustification:
          data.retroactivePaymentJustification ?? '',

        retroactivePaymentDocuments: {
          files: this.getRetroactivePaymentFiles(data.documents || []),
          types: this.getRetroactivePaymentTypes(data.documents || []),
        },
      };
      // we backup the services summary stored
      this.servicesSummaryBackup = [...this.model.servicesSummary];

      this.catalogs.servicesPreviousYear = data.servicesSummaryPreviousYear;
      this.$emit('update:modelToSave', this.model);
      this.fillDocuments();
      this.fillRetroactiveDocuments();
    },
    async getServices() {
      const result = await servicesProvidedApi.getAll(this.tapRequestId);
      if (result?.length > 0 ?? false) {
        this.relatedServices = result.filter(isTapRelatedFilter);
      }
    },
    async fetchAlternativeLocationCategories() {
      const data = await getCentralLevelAlternativeLocationCategories();

      this.catalogs.alternativeLocationCategories = [...data];
    },
    async fetchNumberOfStudents() {
      const data = await getCentralLevelNumberOfStudents();

      this.catalogs.numberOfStudents = [...data];
    },
    async fetchSchoolGrades() {
      const data = await getCentralLevelSchoolGrades();

      this.catalogs.schoolGrades = [...data];
    },
    async fetchServices() {
      const data = await getCentralLevelServices();

      this.catalogs.services = [...data];
    },
    async fetchTherapyServicesFilters() {
      const data = await getTherapyservicesfilters();

      this.catalogs.frequencies = data.frequencies;
      this.catalogs.modalities = data.modalities;
      this.catalogs.durations = data.durations;
    },
    async getCatalogs() {
      const data = await getORERecommendations(
        tapRequestQuestionSectionsEnum.OreRecomendacionNivelCentral
      );
      this.catalogs.oreRecommendations.questionnaire = data;

      await this.fetchAlternativeLocationCategories();
      await this.fetchNumberOfStudents();
      await this.fetchSchoolGrades();
      await this.fetchServices();
      await this.fetchTherapyServicesFilters();
    },
    initTogglers() {
      this.collapseTogglers.schoolRecommendations = !!this.model
        .schoolRecommendations.length;
      this.collapseTogglers.compuRecommendations = !!this.model
        .compuRecommendations.length;
    },
    async getDocumentTypesByCode(code) {
      const { data } = await getDocumentTypesByCode(code);

      if (this.requestTypeId !== REQUEST_TYPES.QUERELLA) {
        const validDocumentTypes = [documentTypes.PropuestaServicios];
        if (this.isStatusProcessAmmendment) {
          validDocumentTypes.push(documentTypes.Otro_2);
        }
        validDocumentTypes.forEach((documentType) => {
          data
            .filter((c) => c.id === documentType)
            .forEach((element) => {
              this.document.documentTypes.push({
                id: element.id,
                name: element.name,
              });
            });
        });
      } else {
        data.forEach((element) => {
          this.document.documentTypes.push({
            id: element.id,
            name: element.name,
          });
        });
      }
    },
    async gettingDocument(data) {
      this.document.data = data;
    },
    fillDocuments() {
      this.document.data = {
        files: [],
        types: [],
      };

      if (this.model.documents && this.model.documents.length > 0) {
        this.model.documents.forEach((element) => {
          // Excluir documentos de pagos retroactivos
          if (
            this.retroactiveDocumentTypeIds.includes(
              element.document.documentTypeId
            )
          ) {
            return;
          }

          this.document.data.files.push({
            name: element.filename,
            peiStatus: element.peiStatus,
            pei: element.peiId,
            documentType: element.document.documentTypeId,
            documentTypeName: element.document.documentTypeName,
            id: element.documentId,
            inServer: true,
            isReport: element.isReport,
            readOnly: element.readOnly,
            createdDate: element.createdDate,
            userName: element.userName,
            userFullName: element.userFullName,
            isAmendmentDocument: element.isAmendmentDocument,
          });

          this.document.data.types.push(element.document.documentTypeId);
        });
      }

      this.documentLength++;
    },
    fillRetroactiveDocuments() {
      this.model.retroactivePaymentDocuments = {
        files: [],
        types: [],
      };

      if (this.model.documents && this.model.documents.length > 0) {
        this.model.documents.forEach((element) => {
          if (
            !this.retroactiveDocumentTypeIds.includes(
              element.document.documentTypeId
            )
          ) {
            return;
          }

          this.model.retroactivePaymentDocuments.files.push({
            name: element.filename,
            peiStatus: element.peiStatus,
            pei: element.peiId,
            documentType: element.document.documentTypeId,
            documentTypeName: element.document.documentTypeName,
            id: element.documentId,
            inServer: true,
            isReport: element.isReport,
            readOnly: element.readOnly,
            createdDate: element.createdDate,
            userName: element.userName,
            userFullName: element.userFullName,
            isAmendmentDocument: element.isAmendmentDocument,
          });

          this.model.retroactivePaymentDocuments.types.push(
            element.document.documentTypeId
          );
        });
      }
      this.retroactiveDocumentLength++;
    },
    async deleteCOMPURecommendation(value) {
      if (!value && this.model.compuRecommendations.length > 0) {
        const deleteResponse = await alert.methods.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información registrada. ¿Está seguro que desea eliminar la información para recomendar que el COMPU se reúna?',
          'Sí',
          'No'
        );

        if (deleteResponse) {
          deleteCOMPURecommendation(
            this.model.id,
            tapRequestQuestionSectionsEnum.OreRecomendacionNivelCentral
          )
            .then(() => {
              this.model.compuRecommendations = [];
            })
            .catch(() => {
              alert.methods.ShowToast(
                'Alerta',
                'Error borrando Recomendaciones de COMPU',
                'error',
                () => (this.collapseTogglers.compuRecommendations = true)
              );
            });
        } else {
          this.collapseTogglers.compuRecommendations = true;
        }
      }
    },
    async deleteSchoolRecommendation(value) {
      if (!value && this.model.schoolRecommendations.length > 0) {
        const deleteResponse = await alert.methods.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información registrada. ¿Está seguro que desea eliminar la información para el proceso de identificar la alternativa de ubicación y/o localización?',
          'Sí',
          'No'
        );

        if (deleteResponse) {
          deleteSchoolRecommendation(this.model.id)
            .then(() => {
              this.model.schoolRecommendations = [];
            })
            .catch(() => {
              alert.methods.ShowToast(
                'Alerta',
                'Error borrando Recomendaciones de Escuela',
                'error',
                () => (this.collapseTogglers.schoolRecommendations = true)
              );
            });
        } else {
          this.collapseTogglers.schoolRecommendations = true;
        }
      }
    },
    async addServiceToSummary(item) {
      if (item.therapyFrequency?.id > 0) {
        const { data: subTotal } = await getServiceTotalCost({
          cost: item.cost,
          frequencyType: item.therapyFrequency?.id,
        });
        item.subTotal = subTotal;
      }
      this.model.servicesSummary.push(item);

      const lookForIsDue = [
        centralLevelServices.MonthlyPayment,
        centralLevelServices.ServiceAssistant,
      ].includes(item.service?.id);
      if (lookForIsDue) {
        const ser = this.servicesSummary.find(
          (x) => x.service?.id === item.service?.id
        );
        if (ser.serviceDate) {
          const { data: isBillDue } = await getServiceToShowBillFlag(
            this.model.academicYearId,
            this.student.schoolId,
            new Date(ser.serviceDate)
          );
          item.isBillDue = isBillDue;
          this.model.servicesSummary = this.model.servicesSummary.map((x) =>
            x.service?.id === item.service?.id ? item : x
          );
        }
      }

      alert.methods.ShowToast(
        'Confirmación',
        'El servicio se ha añadido exitosamente.',
        'success'
      );
    },
    removeServiceFromSummary(serviceId) {
      const index = this.model.servicesSummary
        .map((c) => c.service.id)
        .indexOf(serviceId);

      this.model.servicesSummary.splice(index, 1);

      alert.methods.ShowToast(
        'Confirmación',
        'El servicio ha sido eliminado exitosamente.',
        'success'
      );
    },
    // get the service cost from the company's contract per services only for Service Purchase.
    async onServiceChange(service) {
      this.disableAcceptBtn = false;

      if (this.canWriteCustomCost || !this.tapRequestId) return;

      const relatedServices = this.relatedServices ?? [];

      const relatedServiceFound = relatedServices.find(
        (x) => x?.service?.id === service.disciplineTypeId
      );
      if (!relatedServiceFound) {
        alert.methods.ShowToast(
          'Error',
          'El costo de Terapia no puede ser añadido, ya que no se encuentra documentado en los Servicios Relacionados.',
          'error'
        );
        this.disableAcceptBtn = true;

        return;
      }

      if (this.isSchoolContractDirectPayment) {
        return;
      }

      const { data: resp } = await getServiceCost({
        tapRequestId: this.tapRequestId,
        schoolId: this.destinationLocationSchoolId,
        disciplineTypeId: service.disciplineTypeId,
        durationId: relatedServiceFound?.duration?.id,
        modalityId: relatedServiceFound?.modality?.id,
      });

      this.costByServices.push({
        serviceId: service.id,
        cost: resp,
      });
    },
  },
  watch: {
    destinationLocationSchoolId() {
      if (this.costByServices.length > 0) this.costByServices = [];
    },

    'model.retroactivePaymentDocuments': {
      deep: true,
      handler() {
        this.$emit('update:modelToSave', this.model);
      },
    },

    'model.hasRetroactivePaymentAuthorization'() {
      this.$emit('update:modelToSave', this.model);
    },

    'model.retroactivePaymentJustification'() {
      this.$emit('update:modelToSave', this.model);
    },
  },
};
</script>
